import i18n from "i18next";

export const formatAmount = (amount: number | bigint) => {
  const formatter = new Intl.NumberFormat(i18n.language === "de" ? "de" : "en-GB", {
    style: "currency",
    currency: "EUR",
  }).format(amount);
  return formatter;
};
